import { Pipe, PipeTransform } from '@angular/core';
import { GigsumoConstants } from '../services/GigsumoConstants';

@Pipe({
  name: 'nameFilter',
  standalone: true
})
export class NameFilterPipe implements PipeTransform {

    transform(items: any[], filter: any): any {
    if (!items || !filter) {
      return items;
    }
    // filter items array, items which match and return true will be
    // kept, false will be filtered out
    return items.filter(item =>
      item.firstName.toLowerCase().indexOf(filter.toLowerCase()) !== -1 ||
      item.lastName.toLowerCase().indexOf(filter.toLowerCase()) !== -1
      );
  }


}

@Pipe({
  name: 'MTAPipe',
  pure: false,
  standalone: true
})
export class MtaFilterPipe implements PipeTransform {
  transform(value: string, displayFormat: string) {
      if(!value) return value;
      switch(displayFormat) {
        case 'convertMTA' :
          return (value === GigsumoConstants.MTA || value === GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION || value === GigsumoConstants.MTA_TITLECASE) ? GigsumoConstants.MANAGER : value;
      }
  }
}
